"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseListCollectionActivityRequest = void 0;
const paths_1 = require("./paths");
function parseListCollectionActivityRequest(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        throw new Error('Invalid activity request.');
    const input = value;
    if (Object.keys(input).some((key) => !['collectionId', 'cursor'].includes(key)) ||
        typeof input.collectionId !== 'string')
        throw new Error('Invalid activity request.');
    paths_1.firestorePaths.collection(input.collectionId);
    if (input.cursor === undefined)
        return { collectionId: input.collectionId };
    if (!input.cursor ||
        typeof input.cursor !== 'object' ||
        Array.isArray(input.cursor))
        throw new Error('Invalid cursor.');
    const cursor = input.cursor;
    if (Object.keys(cursor).some((key) => !['seconds', 'nanoseconds', 'eventId'].includes(key)) ||
        !Number.isSafeInteger(cursor.seconds) ||
        cursor.seconds < 0 ||
        !Number.isSafeInteger(cursor.nanoseconds) ||
        cursor.nanoseconds < 0 ||
        cursor.nanoseconds >= 1e9 ||
        typeof cursor.eventId !== 'string')
        throw new Error('Invalid cursor.');
    paths_1.firestorePaths.auditEvent(input.collectionId, cursor.eventId);
    return {
        collectionId: input.collectionId,
        cursor: cursor,
    };
}
exports.parseListCollectionActivityRequest = parseListCollectionActivityRequest;
